<c-brand-moment [image]="image" size="xl"
  [icon]="checkIcon"
  [title]="content()?.title"
  [description]="content()?.description">

  <c-button type="primary-brand" [loading]="loading()" (action)="action.emit()">
    {{ buttonLabel() }}
  </c-button>

  @if (showPrevious()) {
    <c-button type="secondary-brand" [loading]="previousLoading()" (action)="previous.emit()">
      {{ 'common.go-back' | transloco }}
    </c-button>
  }
</c-brand-moment>
